import React, { useState, useEffect, useRef } from "react";
import { Eye, EyeClosed, CircleHelp, X } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import TempStorage from "../../components/Storage.js";
import NavBar from "../../visualComponents/NavBarGenerale.js";
import Tooltip from "../../components/Tooltip.js";

let isLoading = false;


const PopUpAssistenza = ({ isVisible, setIsVisible }) => {

    const closeModal = () => {
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">ASSISTENZA</h2>
                    <Tooltip content="Chiudi">
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>

                </div>
                <div className="flex aling-items-center justify-items-center grid grid-cols-1 gap-2">
                    <p>Se non ricevi la mail di verifica, segui questi passaggi:</p>
                    <p>1. Controlla che l'indirizzo email inserito sia corretto</p>
                    <p>2. Controlla che la mail non sia finita nello spam</p>
                    <p>3. Controlla che la casella di posta non sia piena</p>
                    <p>4. Se non è presente neanche nello spam,<br /> invia una mail a notification@mantego.cloud con le informazioni di contatto</p>
                    <p>5. Dopo qualche minuto riprova a verificare la mail</p>
                </div>
            </div>
        </div>
    );
};

const VerificaMail = ({ isVisible, checkCodice }) => {
    const [codiceVerifica, setCodiceVerifica] = useState("");
    const [isCodiceVisible, setIsCodiceVisible] = useState(false);
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);

    useEffect(() => {
        checkCodice(codiceVerifica);
    }, [codiceVerifica]);

    const handleHelp = () => {
        setIsPopUpVisible(true);
    };

    if (!isVisible) return null;
    return (
        <div className="mt-5 rounded-md border-2 border-dashed">
            <div className="m-2 grid grid-cols-2 items-center">
                <p className="justify-self-start">Codice di verifica: </p>
                <div className="relative flex items-center">
                    <input
                        type={isCodiceVisible ? "text" : "password"}
                        value={codiceVerifica}
                        onChange={(e) => setCodiceVerifica(e.target.value)}
                        className="rounded text-center border-2 border-gray-300 w-full"
                        autoFocus
                    />
                    <Tooltip content="Mostra il codice">
                        <button
                            type="button"
                            onClick={() => setIsCodiceVisible(!isCodiceVisible)}
                            className="absolute right-2 text-gray-500 hover:text-gray-700"
                        >
                            {isCodiceVisible ? (
                                <EyeClosed size={20} />
                            ) : (
                                <Eye size={20} />
                            )}
                        </button>
                    </Tooltip>
                </div>
            </div>
            <p><b><u className="text-blue-600 cursor-pointer" onClick={handleHelp}>Risoluzione problemi con la mail</u></b></p>
            <PopUpAssistenza isVisible={isPopUpVisible} setIsVisible={setIsPopUpVisible} />
        </div>
    );
};

const Dominio = () => {
    const [codiceDominio, setCodiceDominio] = useState("");
    const [ragioneSociale, setRagioneSociale] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    const [cap, setCap] = useState("");
    const [citta, setCitta] = useState("");
    const [provincia, setProvincia] = useState("");
    const [nomeManager, setNomeManager] = useState("");
    const [cognomeManager, setCognomeManager] = useState("");
    const [emailManager, setEmailManager] = useState("");
    const [passwordManager, setPasswordManager] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [confermarePasswordManager, setConfermarePasswordManager] = useState("");
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [isVerifyVisible, setIsVerifyVisible] = useState(false);
    const [codiceVerifica, setCodiceVerifica] = useState("");
    const navigate = useNavigate();
    const inputRefs = useRef([]);

    useEffect(() => {
        if (TempStorage.exists('infoDominio')) {
            const infoDominio = TempStorage.get('infoDominio');
            setCodiceDominio(infoDominio.codice);
            setRagioneSociale(infoDominio.ragione);
            setIndirizzo(infoDominio.indirizzo);
            setCap(infoDominio.cap);
            setCitta(infoDominio.citta);
            setProvincia(infoDominio.provincia);
            setNomeManager(infoDominio.nome);
            setCognomeManager(infoDominio.cognome);
            setEmailManager(infoDominio.email);
            setPasswordManager(infoDominio.password);
        }
    }, []);

    useEffect(() => {
        const input = document.getElementById('confermaPasswordManager');

        if (passwordManager !== confermarePasswordManager) {
            input.classList.add('bg-red-300');
        } else {
            input.classList.remove('bg-red-300');
        }

    }, [confermarePasswordManager, passwordManager]);

    const handleCodiceVerifica = async () => {
        //TODO
        const codice = generateCodiceVerifica();
        try {
            isLoading = true;
            const response = await fetch('/sendCodiceVerifica', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: emailManager, Codice: codice }),
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data['error']);
                return;
            }
            else {
                isLoading = false;
                setCodiceVerifica(codice);
                setIsVerifyVisible(true);
            }
        } catch (error) {
            alert("Errore nell'invio della mail di verifica, riprovare più tardi.");
            console.log(error);
        }
    };

    const generateCodiceVerifica = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let codice = '';
        for (let i = 0; i < 16; i++) {
            if (i > 0 && i % 4 === 0) {
                codice += '-';
            }
            codice += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return codice;
    };

    const checkCodiceVerifica = (codiceInserito) => {
        if (codiceInserito === codiceVerifica && isVerifyVisible) {
            alert('Codice corretto');
            navigate('/dominio/attivazione');
        };
    };

    const checkCodiceDominio = async () => {
        if (codiceDominio === "") return;
        try {
            const response = await fetch('/checkCodiceDominio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ CodiceDominio: codiceDominio }),
            });

            if (response.status === 401) {
                const data = await response.json();
                alert(data['error']);
                setCodiceDominio('');
            }
        } catch (error) {
            alert('Errore nel controllo del codice del dominio, riprovare più tardi.');
            console.log(error);
        }

    };

    const checkEmail = async () => {
        if (emailManager === "") return;
        try {
            const response = await fetch('/checkEmail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ Email: emailManager }),
            });
            if (response.status === 401) {
                const data = await response.json();
                alert(data['error']);
                setEmailManager('');
            }
        } catch (error) {
            alert('Errore nel controllo della mail, riprovare più tardi.');
            console.log(error);
        }

    };

    const checkDati = () => {
        if (codiceDominio === "" || ragioneSociale === "" || indirizzo === "" || cap === "" || citta === "" || provincia === "" || nomeManager === "" || cognomeManager === "" || emailManager === "" || passwordManager === "" || confermarePasswordManager === "") {
            alert('Inserire tutti i campi');
            return false;
        }
        if (passwordManager !== confermarePasswordManager) {
            alert('Le password non corrispondono');
            return false;
        }
        return true;
    };

    const handleVerifica = () => {
        if (!checkDati()) return;
        TempStorage.set('infoDominio', {
            codice: codiceDominio,
            ragione: ragioneSociale,
            indirizzo: indirizzo,
            cap: cap,
            citta: citta,
            provincia: provincia,
            nome: nomeManager,
            cognome: cognomeManager,
            email: emailManager,
            password: passwordManager
        });

        const locked = document.getElementsByClassName('locked');
        for (let i = 0; i < locked.length; i++) {
            locked[i].setAttribute('disabled', 'true');
        }
        handleCodiceVerifica();
    };

    const handleModifica = () => {
        const locked = document.getElementsByClassName('locked');
        for (let i = 0; i < locked.length; i++) {
            locked[i].removeAttribute('disabled');
        }
        setIsVerifyVisible(false);
    };

    const handleLogin = () => {
        TempStorage.remove('infoDominio');
        navigate('/login');
    }

    const checkPassword = () => {
        let check = true;
        const uppercasePattern = /[A-Z]/;
        const lowercasePattern = /[a-z]/;
        const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
        const numberPattern = /[0-9]/;

        if (!uppercasePattern.test(passwordManager)) {
            check = false;
        }
        if (!lowercasePattern.test(passwordManager)) {
            check = false;
        }
        if (!specialCharPattern.test(passwordManager)) {
            check = false;
        }
        if (!numberPattern.test(passwordManager)) {
            check = false;
        }
        if (passwordManager.length < 8) {
            check = false;
        }

        return check;
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    return (
        <div className="flex justify-center min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"MANTEGO"} />
            <div className="p-4 w-full max-w-lg text-center bg-white dark:bg-gray-800 text-black dark:text-white">
                <h1 className="mb-5 mt-14">CREA IL TUO DOMINIO<br />oppure <b><u className="text-blue-600 cursor-pointer" onClick={handleLogin}>esegui la login</u></b></h1>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Codice/P.IVA: </p>
                    <input
                        type="text"
                        value={codiceDominio}
                        onChange={(e) => { setCodiceDominio(e.target.value) }}
                        onBlur={checkCodiceDominio}
                        onKeyDown={(e) => handleKeyDown(e, 0)}
                        ref={(el) => inputRefs.current[0] = el}
                        className={`locked text-center rounded border-2 ${codiceDominio === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Ragione Sociale: </p>
                    <input
                        type="text"
                        value={ragioneSociale}
                        onChange={(e) => { setRagioneSociale(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 1)}
                        ref={(el) => inputRefs.current[1] = el}
                        className={`locked text-center rounded border-2 ${ragioneSociale === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Indirizzo: </p>
                    <input
                        type="text"
                        value={indirizzo}
                        onChange={(e) => { setIndirizzo(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 2)}
                        ref={(el) => inputRefs.current[2] = el}
                        className={`locked text-center rounded border-2 ${indirizzo === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">CAP: </p>
                    <input
                        type="text"
                        value={cap}
                        onChange={(e) => { setCap(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 3)}
                        ref={(el) => inputRefs.current[3] = el}
                        className={`locked text-center rounded border-2 ${cap === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Città: </p>
                    <input
                        type="text"
                        value={citta}
                        onChange={(e) => { setCitta(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 4)}
                        ref={(el) => inputRefs.current[4] = el}
                        className={`locked text-center rounded border-2 ${citta === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Provincia: </p>
                    <input
                        type="text"
                        value={provincia}
                        onChange={(e) => { setProvincia(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 5)}
                        ref={(el) => inputRefs.current[5] = el}
                        className={`locked text-center rounded border-2 ${provincia === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <h3 className="mt-5 mb-5">Informazioni del manager</h3>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Nome: </p>
                    <input
                        type="text"
                        value={nomeManager}
                        onChange={(e) => { setNomeManager(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 6)}
                        ref={(el) => inputRefs.current[6] = el}
                        className={`locked text-center rounded border-2 ${nomeManager === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Cognome: </p>
                    <input
                        type="text"
                        value={cognomeManager}
                        onChange={(e) => { setCognomeManager(e.target.value) }}
                        onKeyDown={(e) => handleKeyDown(e, 7)}
                        ref={(el) => inputRefs.current[7] = el}
                        className={`locked text-center rounded border-2 ${cognomeManager === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2">
                    <p className="justify-self-start">Email: </p>
                    <input
                        type="email"
                        value={emailManager}
                        onChange={(e) => { setEmailManager(e.target.value) }}
                        onBlur={checkEmail}
                        onKeyDown={(e) => handleKeyDown(e, 8)}
                        ref={(el) => inputRefs.current[8] = el}
                        className={`locked text-center rounded border-2 ${emailManager === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1`}
                    />
                </div>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start flex items-center">Password:
                        <Tooltip content="Help">
                            <button
                                type="button"
                                className="text-blue-500 ml-2"
                                onClick={() => alert('La password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale (es. [!@#$%^&*(),.?":{}|<>])')}
                            >
                                <CircleHelp size={20} />
                            </button>
                        </Tooltip>
                    </p>

                    <div className="relative flex items-center">
                        <input
                            type={isPasswordVisible ? "text" : "password"}
                            value={passwordManager}
                            onChange={(e) => { setPasswordManager(e.target.value) }}
                            onKeyDown={(e) => handleKeyDown(e, 9)}
                            ref={(el) => inputRefs.current[9] = el}
                            className={`locked text-center rounded border-2 w-full ${passwordManager === "" || !checkPassword() ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1 flex-1`}
                        />
                        <Tooltip content="Mostra password">
                            <button
                                type="button"
                                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                className="locked absolute right-2 text-gray-500 hover:text-gray-700"
                            >
                                {isPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </Tooltip>

                    </div>
                </div>
                <div className="mb-2 grid grid-cols-2 items-center">
                    <p className="justify-self-start">Conferma password: </p>
                    <div className="relative flex items-center">
                        <input
                            id="confermaPasswordManager"
                            type={isConfirmPasswordVisible ? "text" : "password"}
                            value={confermarePasswordManager}
                            onChange={(e) => { setConfermarePasswordManager(e.target.value) }}
                            onKeyDown={(e) => handleKeyDown(e, 10)}
                            ref={(el) => inputRefs.current[10] = el}
                            className={`locked text-center rounded border-2 w-full ${confermarePasswordManager === "" ? "border-red-500" : "border-gray-300 dark:border-gray-600"} rounded bg-white dark:bg-gray-800 px-1 flex-1`}
                        />
                        <Tooltip content="Mostra password">
                            <button
                                type="button"
                                onClick={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                                className="locked absolute right-2 text-gray-500 hover:text-gray-700"
                            >
                                {isConfirmPasswordVisible ? (
                                    <EyeClosed size={20} />
                                ) : (
                                    <Eye size={20} />
                                )}
                            </button>
                        </Tooltip>
                    </div>
                </div>
                <div className='mt-5 grid grid-cols-2'>
                    <button
                        onClick={handleModifica}
                        className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                    >
                        Modifica
                    </button>
                    <button
                        onClick={handleVerifica}
                        className="mr-1 rounded-lg bg-blue-500 hover:bg-blue-700 text-white font-bold p-2"
                    >
                        Verifica
                    </button>
                </div>
                <VerificaMail
                    isVisible={isVerifyVisible}
                    checkCodice={checkCodiceVerifica}
                />
            </div>
        </div>
    );
};

export default Dominio;